var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 124.94,
    viewBox: "0 0 120 124.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#0090ff;}.a{opacity:0;}.b,.c,.f{fill-rule:evenodd;}.c{fill:#323232;}.d{fill:#0084eb;}.e{fill:#0073cc;}.f{fill:#3eaaf3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408.75 -3449)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 120,
    height: 124.94,
    transform: "translate(408.75 3449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.327,0A30,30,0,0,1,60.183,27.037L60.327,27,65.1,51.811A1,1,0,0,1,64.117,53H59.562L57.743,68.467A4,4,0,0,1,53.77,72H41.113L37.17,90.557,0,82.656,2.926,68.892q.081-1.074.4-2.892c3-17-3-20-3-36q0-.118,0-.233l0-.263A30,30,0,0,1,30.327,0Z",
    transform: "translate(436 3466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M33.885,72.024l.314,0h6.786l-1.275,6H37.328a18,18,0,0,1-18-18V59A15,15,0,0,0,33.885,72.024Z",
    transform: "translate(436 3466)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(444.327 3474)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(453.327 3483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.327,21l8,4.5v9l-8,4.5-8-4.5v-9Z",
    transform: "translate(436 3466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M30.327,21l8,4.5-8,4.5-8-4.5Z",
    transform: "translate(436 3466)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIcon);
export default __webpack_public_path__ + "static/media/head-icon.75fb80e45fa516f34b43cd21b94b8d49.svg";
export { ForwardRef as ReactComponent };